import React from 'react'
import PropTypes from 'prop-types'
import MediaQuery from 'react-responsive'

import { UI } from '../config'

export const breakpoints = {
  desktop: `(min-device-width: ${UI.MOBILE_WIDTH + 1}px)`,
  //TODO: tablets Media queries
  //tablet: '(min-width: 768px) and (max-width: 1024px)',
  mobile: `(max-device-width: ${UI.MOBILE_WIDTH}px)`,
  mobileLandscape: `(max-device-width: ${UI.MOBILE_WIDTH}px) and (orientation:landscape)`,
  mobilePortrait: `(max-device-width: ${UI.MOBILE_WIDTH}px) and (orientation:portrait)`,
}

const { string, any } = PropTypes

export default function Media(props) {
  const breakpoint = breakpoints[props.type] || breakpoints.mobile
  return (
    <MediaQuery {...props} type={null} query={breakpoint}>
      {props.children}
    </MediaQuery>
  )
}
Media.propTypes = {
  type: string,
  children: any,
}
